<script>
  import { apiFetch } from "../../lib/api.js";
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { formatNumber } from "../../services/formatNumber"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/user"
  import Alert from "../Alert.svelte"
  import CountrySelect from "../CountrySelect.svelte"

  export let id_usuario = 0
  let isLoading = true
  let isSeting = false

  let acciones = false

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 5000,
  }

  let usuario = {
    usuario: "",
    cliente: "",
    tipo_documento: "",
    documento: "",
    nombres: "",
    inicio: "0001-01-01",
    fin: "0001-01-01",
    consultas: 0,
    consultas_contrato: 0,
    consumo: 0,
    consultas_masivas: 0,
    estado: "0",
    rol: "2",
    plan: "",
    celular: "",
    celular_codigo: "51",
  }

  const getDatos = async () => {
    const response = await apiFetch(
      `${BASE_URL}usuario.php?action=getDatos&id=${id_usuario}`,
    )
    const resp = await response.json()
    usuario = resp.data
    usuario.consultas_contrato = formatNumber(usuario.consultas_contrato)
    usuario.consultas = formatNumber(usuario.consultas)
    usuario.consumo = formatNumber(usuario.consumo)
    usuario.consultas_masivas = formatNumber(usuario.consultas_masivas)
    usuario.consultas_filtros = formatNumber(usuario.consultas_filtros)
    isLoading = false
  }

  const setDatos = async () => {
    if (
      !esCelularValido(usuario.celular, usuario.celular_codigo) &&
      usuario.celular != ""
    ) {
      alert.show = true
      alert.message = "Por favor, ingresa un número de celular válido"
      alert.status = "danger"
      return
    }

    alert.show = false
    isSeting = true
    const formData = new FormData()
    formData.append("id_usuario", id_usuario)
    formData.append("usuario", usuario.usuario)
    formData.append("cliente", usuario.cliente)
    formData.append("nombres", usuario.nombres)
    formData.append("inicio", usuario.inicio)
    formData.append("fin", usuario.fin)
    formData.append("consultas", usuario.consultas.replace(/[^\d.]/g, ""))
    formData.append(
      "consultas_contrato",
      usuario.consultas_contrato.replace(/[^\d.]/g, ""),
    )
    formData.append("consumo", usuario.consumo.replace(/[^\d.]/g, ""))
    formData.append("estado", usuario.estado)
    formData.append("rol", usuario.rol)
    formData.append("action", "setDatos")
    formData.append("session_id_usuario", $user.idUsuario)
    formData.append("plan", usuario.plan)
    formData.append("celular", usuario.celular)
    formData.append("celular_codigo", usuario.celular_codigo)
    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    })
    const resp = await response.json()
    if (resp.status == "success") {
      getDatos()
      alert.show = true
      alert.message = "Datos actualizados"
      alert.status = "success"
    } else {
      alert.show = true
      alert.message = resp.message || "Error al actualizar los datos"
      alert.status = "danger"
    }
    isSeting = false
  }

  const handleConsultasContratoInput = (event) => {
    const formattedValue = formatNumber(event.target.value)
    usuario.consultas_contrato = formattedValue
  }

  const handleConsultasInput = (event) => {
    const formattedValue = formatNumber(event.target.value)
    usuario.consultas = formattedValue
  }

  const handleConsumoInput = (event) => {
    const formattedValue = formatNumber(event.target.value)
    usuario.consumo = formattedValue
  }

  const esCelularValido = (str, pais) => {
    if (pais == "51") {
      // Perú: empieza con 9 y tiene 9 dígitos
      return /^9\d{8}$/.test(str)
    } else if (pais == "52") {
      // México: empieza con 55, 56 o 33, o cualquier otro código válido, y tiene 10 dígitos
      return /^\d{10}$/.test(str)
    } else if (pais == "1") {
      // Estados Unidos: 10 digitos
      return /^1?\d{10}$/.test(str)
    }
    return false
  }

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true
    }
  })

  getDatos()
</script>

<div>
  {#if !isLoading}
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-usuario" class="col-form-label">Usuario</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-8">
        <input
          type="text"
          id="u-usuario"
          bind:value={usuario.usuario}
          class="form-control"
          disabled
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-cliente" class="col-form-label">Cliente</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-8">
        <input
          type="text"
          id="u-cliente"
          bind:value={usuario.razon_social}
          class="form-control"
          disabled
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-cliente" class="col-form-label"
          >Tipo Doc. / Documento</label
        >
      </div>
      <div class="col-12 col-sm-12 col-lg-4">
        <input
          type="text"
          id="u-cliente"
          bind:value={usuario.tipo_documento}
          class="form-control"
          disabled
        />
      </div>
      <div class="col-12 col-sm-12 col-lg-4">
        <input
          type="text"
          id="u-cliente"
          bind:value={usuario.documento}
          class="form-control"
          disabled
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-nombres" class="col-form-label">Nombres</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-8">
        <input
          type="text"
          id="u-nombres"
          bind:value={usuario.nombres}
          class="form-control"
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-celular" class="col-form-label">Celular</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-8 d-flex gap-2">
        <CountrySelect bind:selected={usuario.celular_codigo} />
        <input
          type="text"
          id="u-celular"
          bind:value={usuario.celular}
          class="form-control"
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-contrato" class="col-form-label">Contrato actual</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-4">
        <input
          type="date"
          id="u-contrato"
          bind:value={usuario.inicio}
          class="form-control"
        />
      </div>
      <div class="col-12 col-sm-12 col-lg-4">
        <input
          type="date"
          id="u-contrato"
          bind:value={usuario.fin}
          class="form-control"
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-lg-4">
        <label for="u-consultas_contrato" class="col-form-label"
          >Consultas contratadas</label
        >
      </div>
      <div class="col-12 col-lg-8">
        <input
          type="text"
          id="u-consultas_contrato"
          bind:value={usuario.consultas_contrato}
          on:input={handleConsultasContratoInput}
          class="form-control"
        />
      </div>
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-consultas" class="col-form-label"
          >Consultas / Consumo</label
        >
      </div>
      <div class="col-12 col-sm-12 col-lg-4">
        <input
          type="text"
          id="u-consultas"
          bind:value={usuario.consultas}
          on:input={handleConsultasInput}
          class="form-control"
        />
      </div>
      <div class="col-12 col-sm-12 col-lg-4">
        <input
          type="text"
          id="u-consumo"
          bind:value={usuario.consumo}
          on:input={handleConsumoInput}
          class="form-control"
          disabled
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-lg-4">
        <label for="u-consultas_masivas" class="col-form-label"
          >Cant. Masivos / Cant. Filtros</label
        >
      </div>
      <div class="col-12 col-lg-4">
        <input
          type="text"
          id="u-consultas_masivas"
          bind:value={usuario.consultas_masivas}
          class="form-control"
          disabled
        />
      </div>
      <div class="col-12 col-lg-4">
        <input
          type="text"
          id="u-consultas_filtros"
          bind:value={usuario.consultas_filtros}
          class="form-control"
          disabled
        />
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-estado" class="col-form-label">Estado</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-8">
        <select class="form-select" id="u-estado" bind:value={usuario.estado}>
          <option value="1">Activo</option>
          <option value="2">Suspendido</option>
          <option value="0">De baja</option>
        </select>
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-rol" class="col-form-label">Rol</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-8">
        <select class="form-select" id="u-rol" bind:value={usuario.rol}>
          <option value="2">Usuario</option>
          <option value="1">Administrador</option>
        </select>
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-4">
        <label for="u-plan" class="col-form-label">Plan</label>
      </div>
      <div class="col-12 col-sm-12 col-lg-8">
        <select class="form-select" id="u-plan" bind:value={usuario.plan}>
          <option value=""></option>
          <option value="Bronze I">Bronze I</option>
          <option value="Bronze II">Bronze II</option>
          <option value="Silver I">Silver I</option>
          <option value="Silver II">Silver II</option>
          <option value="Gold I">Gold I</option>
          <option value="Gold II">Gold II</option>
          <option value="Platinum">Platinum</option>
          <option value="Signature">Signature</option>
          <option value="Ilimitado I">Ilimitado I</option>
          <option value="Ilimitado II">Ilimitado II</option>
          <option value="Ilimitado III">Ilimitado III</option>
          <option value="Ilimitado IV">Ilimitado IV</option>
          <option value="Grupal III">Grupal III</option>
          <option value="Grupal II">Grupal II</option>
          <option value="Grupal I">Grupal I</option>
          <option value="API">API</option>
        </select>
      </div>
    </div>
    <div class="row mb-2 g-2">
      <div class="col-12 col-sm-12 col-lg-12 text-end">
        {#if acciones}
          {#if isSeting}
            <button class="btn btn-primary" disabled> Actualizando... </button>
          {:else}
            <button class="btn btn-primary" on:click={setDatos}>
              Actualizar
            </button>
          {/if}
        {/if}
      </div>
    </div>
  {/if}

  {#if alert.show}
    <Alert message={alert.message} status={alert.status} time={alert.time} />
  {/if}
</div>
